import { signal } from '@angular/core';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { HighIceWaterSvgComponent } from './high-ice-water-svg/high-ice-water-legend-svg';

export const HIGH_ICE_WATER_LEGEND: TwcLegendParams = {
  title: 'HIGH ICE (HIWC)',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: HighIceWaterSvgComponent },
  legendComponent: TwcLegendComponent
};
